import ApplicationSerializer from './application';

export default class EmployeeSignInFieldActionsContactSerializer extends ApplicationSerializer {
  modelNameFromPayloadKey(key) {
    if (key === 'sign-in-field-action-rule-groups') {
      return 'employee-sign-in-field-action-rule-group';
    } else if (key === 'sign-in-field-actions-contacts') {
      return 'employee-sign-in-field-actions-contact';
    } else if (key === 'sign-in-field-actions') {
      return 'employee-sign-in-field-action';
    } else {
      return super.modelNameFromPayloadKey(...arguments);
    }
  }

  payloadKeyFromModelName(modelName) {
    if (modelName === 'employee-sign-in-field-action-rule-group') {
      return 'sign-in-field-action-rule-groups';
    } else if (modelName === 'employee-sign-in-field-actions-contact') {
      return 'sign-in-field-actions-contacts';
    } else {
      return super.payloadKeyFromModelName(...arguments);
    }
  }
}
